import React from 'react';
import { MenuItemArgs } from './types';
import { IconUnlinkScenario, IconUnlinkControl, IconUnlinkPlan } from './icons';
import { Poppins } from 'src/common';
import { mpEvent, MPEvents } from 'src/utils/mixpanel';
import * as S from './util.styles';

export const UNLINK_SCENARIO = ({ label, exe, divider, resetActiveItem, activeItem, setActiveItem }: MenuItemArgs) => (
  <div key="un-s">
    <S.Item
      onClick={(e) => {
        exe(e);
        mpEvent(MPEvents.ButtonClick, {
          button: 'Elipsis:UnlinkScenario',
        });
      }}
      onMouseEnter={() => setActiveItem('un-s')}
      onMouseLeave={resetActiveItem}
      data-cy="common-menu-un-s"
    >
      <div className="icon-container">
        <IconUnlinkScenario isActive={activeItem === 'un-s'} />
      </div>
      <Poppins px={16}>{label || 'Unlink Scenario'}</Poppins>
    </S.Item>
    {divider && <div className="divider" />}
  </div>
);

export const UNLINK_INCIDENT = ({ label, exe, divider, resetActiveItem, activeItem, setActiveItem }: MenuItemArgs) => (
  <div key="un-inc">
    <S.Item
      onClick={(e) => {
        exe(e);
        mpEvent(MPEvents.ButtonClick, {
          button: 'Elipsis:UnlinkIncident',
        });
      }}
      onMouseEnter={() => setActiveItem('un-inc')}
      onMouseLeave={resetActiveItem}
      data-cy="common-menu-un-inc"
    >
      <div className="icon-container">
        <IconUnlinkScenario isActive={activeItem === 'un-inc'} />
      </div>
      <Poppins px={16}>{label || 'Unlink Incident'}</Poppins>
    </S.Item>
    {divider && <div className="divider" />}
  </div>
);

export const UNLINK_CONTROL = ({ label, exe, divider, resetActiveItem, activeItem, setActiveItem }: MenuItemArgs) => (
  <div key="un-cont">
    <S.Item
      onClick={(e) => {
        exe(e);
        mpEvent(MPEvents.ButtonClick, {
          button: 'Elipsis:UnlinkControl',
        });
      }}
      onMouseEnter={() => setActiveItem('un-cont')}
      onMouseLeave={resetActiveItem}
      data-cy="common-menu-un-cont"
    >
      <div className="icon-container">
        <IconUnlinkControl isActive={activeItem === 'un-cont'} />
      </div>
      <Poppins px={16}>{label || 'Unlink Control'}</Poppins>
    </S.Item>
    {divider && <div className="divider" />}
  </div>
);

export const UNLINK_PLAN = ({ label, exe, divider, resetActiveItem, activeItem, setActiveItem }: MenuItemArgs) => (
  <div key="un-p">
    <S.Item
      onClick={(e) => {
        exe(e);
        mpEvent(MPEvents.ButtonClick, {
          button: 'Elipsis:UnlinkPlan',
        });
      }}
      onMouseEnter={() => setActiveItem('un-p')}
      onMouseLeave={resetActiveItem}
      data-cy="common-menu-un-p"
    >
      <div className="icon-container">
        <IconUnlinkPlan isActive={activeItem === 'un-p'} />
      </div>
      <Poppins px={16}>{label || 'Unlink Plan'}</Poppins>
    </S.Item>
    {divider && <div className="divider" />}
  </div>
);

export const LINK_SCENARIO = ({ label, exe, divider, resetActiveItem, activeItem, setActiveItem }: MenuItemArgs) => (
  <div key="link-scenario">
    <S.Item
      onClick={exe}
      onMouseEnter={() => setActiveItem('link-scenario')}
      onMouseLeave={resetActiveItem}
      data-cy="common-menu-link-scenario"
    >
      <div className="icon-container">
        <IconUnlinkScenario isActive={activeItem === 'link-scenario'} />
      </div>
      <Poppins px={16}>{label || 'Link Scenario'}</Poppins>
    </S.Item>
    {divider && <div className="divider" />}
  </div>
);
